
import ComponentInterface from '../../../core/component-interface';
import { pluck } from '../../lib/lib';

class BubbleDatasetGroup extends ComponentInterface {
  /**
   * constructor function this class
   */
  constructor () {
    super();
    this.setState('visible', true);
  }
  /**
   * Create child containers
   */
  createContainer () {
    let manager = this,
      key,
      animationManager = manager.getFromEnv('animationManager'),
      parent = manager.getLinkedParent(),
      pContainer,
      parentChildContainers = parent.getChildContainer();

    for (key in parentChildContainers) {
      pContainer = parentChildContainers[key];

      !manager.getChildContainer(key) && manager.addChildContainer(key,
        animationManager.setAnimation({
          el: 'group',
          attr: {name: 'manager-' + key},
          component: manager,
          container: pContainer
        }));
    }
  }

  /**
   * function call sync draw of its children
   */
  draw () {
    this.createContainer();
  }

  getDataLimitRange () {
    var vcanvas = this,
      children = vcanvas.getChildren(),
      i,
      key,
      child,
      len,
      limits,
      zMax = -Infinity,
      zMin = +Infinity,
      xMax = -Infinity,
      xMin = +Infinity;

    for (key in children) {
      if (children.hasOwnProperty(key)) {
        child = children[key];
        if (child instanceof Array) {
          len = child.length;
          for (i = 0; i < len; i++) {
            limits = child[i].getDataLimits();
            xMax = Math.max(xMax, limits.xMax || -Infinity);
            xMin = Math.min(xMin, limits.xMin || +Infinity);
            zMax = Math.max(zMax, limits.zMax || -Infinity);
            zMin = Math.min(zMin, limits.zMin || +Infinity);
          }
        }
      }
    }

    zMax = zMax === -Infinity ? 0 : zMax;
    zMin = zMin === +Infinity ? 0 : zMin;
    return {
      xMax: xMax,
      xMin: xMin,
      zMax: zMax,
      zMin: zMin
    };
  }

  /**
   * function to accomodate the changes of its child and notify its parent for further action if its needed
   * @param  {Object} updateInfo is an object with the informations about the changes in its child
   */
  childChanged (updateInfo = {}) {
    let manager = this,
      config = manager.config,
      parent = manager.getLinkedParent(),
      range,
      padding,
      changeInfo = {},
      ifInformParent;

    if (updateInfo.hide !== false || updateInfo.show !== false) {
      manager._mapChildren((child) => {
        child.setState('dirty', true);
      });
      ifInformParent = true;
    }
    if (updateInfo.dataLimitChanged !== false) {
      range = manager.getDataLimits();
      if (range.min !== config.range.min || range.max !== config.range.max) {
        config.range.min = range.min;
        config.range.max = range.max;
        changeInfo.dataLimitChanged = true;
        ifInformParent = true;
      }
    }
    if (updateInfo.paddingChanged !== false) {
      padding = manager.getAxisValuePadding();
      if (padding.left !== config.padding.left || padding.right !== config.padding.right) {
        config.padding.left = padding.left;
        config.padding.right = padding.right;
        changeInfo.paddingChanged = true;
        ifInformParent = true;
      }
    }
    if (ifInformParent) {
      parent.childChanged && parent.childChanged(changeInfo);
    } else {
      manager.asyncDraw();
    }
  }
  /**
   * function to get value for axis padding from is children
   * @return {Object} with left and right member
   */
  getAxisValuePadding () {
    let paddingObj = {},
      axisPaddingLeft = -Infinity,
      axisPaddingRight = -Infinity;
    this._mapChildren((child) => {
      if (child.getState('removed') || child.getState('visible') === false) {
        return;
      }
      paddingObj = (child.getAxisValuePadding && child.getAxisValuePadding()) || {};
      axisPaddingLeft = Math.max(axisPaddingLeft, paddingObj.left || -Infinity);
      axisPaddingRight = Math.max(axisPaddingRight, paddingObj.right || -Infinity);
    });
    if (axisPaddingLeft === -Infinity) {
      axisPaddingLeft = 0;
    }
    if (axisPaddingRight === -Infinity) {
      axisPaddingRight = 0;
    }
    if (!this.config.padding) {
      this.config.padding = {};
      this.config.padding.left = axisPaddingLeft;
      this.config.padding.right = axisPaddingRight;
    }
    return {
      left: axisPaddingLeft,
      right: axisPaddingRight
    };
  }
  /**
   * function to calculate maximum canvas padding is required by the children of this manager
   * @return {Object} contains dimension required
   */
  getCanvasPadding () {
    var manager = this,
      dim,
      key,
      returnDimension = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
    manager._mapChildren((child) => {
      if (child.getState('removed')) {
        return;
      }
      dim = (child.getCanvasPadding && child.getCanvasPadding()) || {};
      for (key in dim) {
        if (dim.hasOwnProperty(key)) {
          returnDimension[key] = Math.max(dim[key], returnDimension[key]);
        }
      }
    });
    return returnDimension;
  }
  /**
   * function to get data limits from its child datasets
   * return minimun and maximum value among the datasets limit
   * @return {Object} [min, max]
   */
  getDataLimits () {
    var manager = this,
      chart = manager.getFromEnv('chart'),
      infMin = -Infinity,
      infMax = +Infinity,
      max = infMin,
      min = infMax,
      xMin = infMax,
      xMax = infMin,
      maxminObj,
      xMaxValue,
      xMinValue,
      getMaxMin = function (_maxminObj) {
        xMaxValue = pluck(_maxminObj.xMax, infMin);
        xMinValue = pluck(_maxminObj.xMin, infMax);
        max = Math.max(max, _maxminObj.max);
        min = Math.min(min, _maxminObj.min);
        xMax = Math.max(xMax, xMaxValue);
        xMin = Math.min(xMin, xMinValue);
      };

    manager._mapChildren((child) => {
      if (!child.getDataLimits || child.getState('removed')) {
        return;
      }
      maxminObj = child.getDataLimits();
      getMaxMin(maxminObj);
    });

    (max === -Infinity) && (max = 0);
    (min === +Infinity) && (min = 0);
    if (!this.config.range) {
      this.config.range = {};
      this.config.range.min = min;
      this.config.range.max = max;
      this.config.range.xMin = xMin;
      this.config.range.xMax = xMax;
    }
    chart.config.yMax = max;
    chart.config.yMin = min;

    return { min, max, xMin, xMax };
  }
  /**
   * it return the status of dataset visiblity
   * @return {boolean} returns the visiblity status of dataset
   */
  isVisible () {
    return !this.isNotVisible;
  }
  getType () {
    return 'manager';
  }
  getName () {
    return 'BubbleGroupManager';
  }
  remove () {
    let manager = this;
    manager._mapChildren((child) => {
      if (!child.getState('removed')) {
        child.remove();
      }
    });
    super.remove();
  }
}
export default BubbleDatasetGroup;
